/**
 * Master switch for the Arabic blog layer.
 *
 * The blog has a complete Arabic content layer — `body.ar.mdx` + `ar.tsx` per
 * post, an Arabic index in `src/app/[locale]/blog/ar.ts`, and Arabic registries
 * under `src/lib/comparison/ar/` and `src/lib/alternatives/ar/`. Translation is
 * only partially finished, so `/ar/blog` is served in English for now rather
 * than as a mix of Arabic and English articles.
 *
 * Nothing is deleted. Every gate is `locale === 'ar' && BLOG_AR_ENABLED`, so
 * flipping this to `true` turns the whole Arabic blog back on at once —
 * including the posts already translated.
 *
 * This affects the blog ONLY. Voice, telephony, integrations, templates and the
 * rest of the marketing site render Arabic on `/ar` regardless of this flag.
 */
export const BLOG_AR_ENABLED = false;

/**
 * The locale the blog's Arabic resolvers should actually be given.
 *
 * Collapses to `'en'` while the Arabic blog is switched off, so every
 * `localize*` helper short-circuits and returns its English record by
 * reference — no spread, no partial merge.
 */
export function blogLocale(locale: string): string {
  return BLOG_AR_ENABLED ? locale : 'en';
}
